// Frontend-only settings residue with no Swift source (kept hand-written).
import { IUnitLength, IUnitWeight, IUnitSpeed, IUnitTemperature, IUnitVolume, IUnitSurface, IUnitCurrency, IUnitDistance, IUnitPower, IUnitWind, IUnitPressure, IUnitCurrent } from "./Generated/LogbookModel/Settings/ShipSettings"

export interface ISettingConfigurableList {
  id: string;
  listItem?: string;
}

export interface ISettingConfigurableLists {
  seaState: ISettingConfigurableList[];
  comment: ISettingConfigurableList[];
  [key: string]: ISettingConfigurableList[];
}

export const IUnitDefault = {
  length: IUnitLength.m,
  weight: IUnitWeight.kg,
  speed: IUnitSpeed.kn,
  temperature: IUnitTemperature.celsius,
  volume: IUnitVolume.l,
  surface: IUnitSurface.m2,
  currency: IUnitCurrency.eur,
  distance: IUnitDistance.nm,
  power: IUnitPower.kw,
  wind: IUnitWind.kn,
  pressure: IUnitPressure.hpa,
  current: IUnitCurrent.kn,
};
